'use strict';
var uncurryThis = require('../internals/function-uncurry-this');

module.exports = uncurryThis({}.isPrototypeOf);



//////////////////
// WEBPACK FOOTER
// ./~/recharts/~/core-js/internals/object-is-prototype-of.js
// module id = 520
// module chunks = 0